import React, { useState } from 'react';
import { Container, Modal, Tab, Tabs, Button } from 'react-bootstrap';
import './SetupTimeshareScreen.css';

function SetupTimeshareScreen() {
  const [showModal, setShowModal] = useState(true);
  const [activeTab, setActiveTab] = useState('configuration');

  const handleCloseModal = () => {
    // Modal can only be closed by clicking the X button or specific buttons
    // This prevents accidental closing
  };

  const handleModalClose = () => {
    setShowModal(false);
    setActiveTab('configuration');
  };

  const handleSaveAndClose = () => {
    // Save any changes and close modal
    setShowModal(false);
    setActiveTab('configuration');
  };

  const handleSave = () => {
    // Save any changes but keep modal open
    console.log('Saving changes...');
  };

  return (
    <Container fluid className="setup-timeshare-screen">
      <div className="screen-header">
        <h1>Setup - Timeshare</h1>
        <p>Configure timeshare settings and management</p>
      </div>

      <div className="screen-content">
        {/* Main Setup Modal */}
        <Modal 
          show={showModal} 
          onHide={handleCloseModal}
          size="xl"
          backdrop="static"
          keyboard={false}
          className="setup-modal"
        >
          <Modal.Header>
            <Modal.Title>Setup - Timeshare</Modal.Title>
            <Button
              variant="link"
              onClick={handleModalClose}
              className="close-button"
            >
              ×
            </Button>
          </Modal.Header>
          
          <Modal.Body>
            <Tabs
              activeKey={activeTab}
              onSelect={(k) => setActiveTab(k)}
              className="setup-tabs"
            >
              <Tab eventKey="configuration" title="Configuration">
                <div className="tab-content">
                  <h4>Configuration</h4>
                  <p>Configuration options will be added here in the future.</p>
                </div>
              </Tab>
            </Tabs>
          </Modal.Body>
          
          <Modal.Footer>
            <Button onClick={handleSaveAndClose}>
              Save & Close
            </Button>
            <Button onClick={handleSave}>
              Save
            </Button>
            <Button onClick={handleModalClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </Container>
  );
}

export default SetupTimeshareScreen;
